import factory from '../requestFactory';

export default ({sms_code,sms_token}) => {
    return factory()
        .post('/patient/check-user', {
            sms_code:sms_code,
            sms_token:sms_token,
        });
}
